<!--
Timetable screen
@author bmk11u
-->
<template>
  <div
    id="contain"
    class="container"
  >
    <Nav name="Timetable" />
    <Spinner ref="spinner_ref" />
    <main class="p-2">
      <FullCalendar ref='fc_ref' :options="calendarOptions" />
    </main>
    <NewModalPopup
      v-if="showTimetablePopup"
      id="event"
      :show-x="true"
      :title="eventType(event.extendedProps.classif)"
      @close="showTimetablePopup = false"
    >
      <table class="dialogueTable">
        <tr v-if="event.extendedProps.isUserBooking">
          <th>Title</th>
          <td>{{ event.title }}</td>
        </tr>
        <tr v-if="!event.extendedProps.isUserBooking">
          <th>Location</th>
          <td v-if="!event.extendedProps.classif">
            <b>ON CAMPUS</b>
          </td>
          <td v-if="event.extendedProps.classif == 'ONANY' || event.extendedProps.classif == 'ONLIVE'">
            <b>OFF CAMPUS</b>
          </td>
          <td v-if="event.extendedProps.classif == 'TBA'">
            <b>TBA</b>
          </td>
          <td v-if="event.extendedProps.classif == 'RN' || event.extendedProps.classif == 'EXT' ">
            <b>ON CAMPUS</b>
          </td>
        </tr>
        <tr v-if="!event.extendedProps.room && event.extendedProps.classif && event.extendedProps.classif != 'TBA' && event.extendedProps.classif != 'RN' && event.extendedProps.classif != 'EXT'">
          <th />
          <td id="room">
            <b>{{ humanify(event.extendedProps.classif) }}</b>
          </td>
        </tr>
        <tr v-if="!event.extendedProps.room && ( event.extendedProps.classif == 'ONANY' || event.extendedProps.classif == 'ONLIVE')">
          <th />
          <td><b>See <a href="https://moodle.gla.ac.uk/login/index.php">Moodle</a> for details.</b></td>
        </tr>
        <tr v-if="!event.extendedProps.isUserBooking">
          <th>Course</th>
          <td>{{ formatText(event.extendedProps.course) }}</td>
        </tr>
        <tr v-if="event.extendedProps.room">
          <th>Room</th>
          <td id="room">
            <a
              v-if="event.extendedProps.room"
              :href="linkToMaps(event.extendedProps.roomid,event.extendedProps.roomgrpcode)"
              data-dismiss="modal"
            >
              {{ event.extendedProps.room }}
          </a>
          </td>
        </tr>
        <tr v-if="!event.extendedProps.room && ( event.extendedProps.classif != 'ONANY' || event.extendedProps.classif != 'ONLIVE')">
          <th>Room</th>
          <td id="room">
            <b>{{ event.extendedProps.location }}</b>
          </td>
        </tr>
        <tr v-if="!event.extendedProps.isUserBooking">
          <th>Class Type</th>
          <td>{{ event.extendedProps.classType }}</td>
        </tr>
        <tr>
          <th>Date</th>
          <td>{{ event.startDate }}</td>
        </tr>
        <tr>
          <th>Start</th>
          <td>{{ event.startTime }}</td>
        </tr>
        <tr>
          <th>Finish</th>
          <td>{{ event.endTime }}</td>
        </tr>
        <tr v-if="!event.extendedProps.isUserBooking && showLecturer">
          <th>Lecturer</th>
          <td>{{ formatText(event.extendedProps.lecturer) }}</td>
        </tr>
        <tr
          v-if="!event.extendedProps.isUserBooking"
          id="detailsPopup"
        >
          <th>Details</th>
          <td v-if="zoomLink">
            <a :href="zoomLink">Join Zoom Meeting</a>
          </td>
          <th v-if="zoomLink" />
          <td>{{ otherDetails }}</td>
        </tr>
      </table>
    </NewModalPopup>
    <div id="pusher" />
    <Footer active="timetable" />
  </div>
</template>

<script setup>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import momentPlugin from '@fullcalendar/moment'
import interactionPlugin from '@fullcalendar/interaction'
import axios from 'axios'
import Spinner from '@/components/Spinner.vue'
// import $cookies from 'vue-cookies'
import { useCalendarMethods } from '@/composables/CalendarMethods.js'
import { useTimetableMethods } from '@/composables/TimetableMethods.js'
import NewModalPopup from '@/components/NewModalPopup.vue'
import Nav from '@/components/Navbar.vue'
import Footer from '@/components/FooterMenu.vue'
import { useUserMethods } from '@/composables/UserMethods.js'
import roomedIcon from '@/assets/index/on_campus.svg'
import liveIcon from '@/assets/index/online_live.svg'
import anytimeIcon from '@/assets/index/recorded.svg'
import bookingIcon from '@/assets/index/room_booking.svg'
import locationIcon from '@/assets/index/location_details.svg'
import moodleIcon from '@/assets/index/see_moodle.svg'
import expandChev from '@/assets/index/expandChev.svg'
import * as lst from '@/components/localStorage.js'
import { ref, onMounted } from 'vue'

// use composables
const { isStudent } = useUserMethods()
// const { fc, next, prev, dateToUnixTs, moment } = useCalendarMethods()
// const { eventType, formatDetails, formatText, getBuildingId, getPlace,
//  humanify, linkToMaps, listviewDescriptionElem, toggleExpandDiv } = useTimetableMethods()
// const { fc, next, prev, dateToUnixTs, moment } = useCalendarMethods()
const { fc, dateToUnixTs, moment } = useCalendarMethods()
const { eventType, formatDetails, formatText,
  humanify, linkToMaps, listviewDescriptionElem, toggleExpandDiv } = useTimetableMethods()

  // mixins: [ CalendarCommon, UserCommon, TimetableDisplay ],

    // -- OLD DATA BLOCK
    const showTimetablePopup = ref(false)

      /* calendarPlugins: [ dayGridPlugin, timeGridPlugin, listPlugin, momentPlugin, interactionPlugin ], */
    const calendarOptions = ref({
        plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, momentPlugin, interactionPlugin ],
        weekNumberCalculation: 'ISO',
        contentHeight: 'auto',
        initialView: 'listWeek',
        eventClick: onEventClick,
        dateClick: onDateClick,
        eventDisplay: 'list-item',
        noEventsContent: 'You have no events scheduled',
        views: {
          list: { /* day/week view */
            listDayFormat: 'dddd DD/MM/yyyy', // 'Monday 24/04/2023' on the lhs
            listDaySideFormat: false, // nothing on the rhs
            titleFormat: { year: 'numeric', month: 'short', day: 'numeric' },
            eventTimeFormat: 'H:mm'
          },
          dayGrid: { /* month view */
            dayHeaderFormat: {
              weekday: 'short' // so far nothing shorter than 'Mon', 'Tue'
            },
            titleFormat: {
              month: 'short',
              year: 'numeric'
            }
          }
        },
        headerToolbar: {
          left: 'listDay,listWeek,dayGridMonth,title',
          center: '',
          right: 'prev,next,today'
        },
        buttonText: { today: 'Today', day: 'DAY', week: 'WEEK', month: 'MONTH' },
        eventContent: renderEvent,
        eventDidMount: postFormatEvent /* for the bar in the middle in list view */
      })
      // ^^^END OF CALENDAR CONFIG!!!

      // component refs here
      const spinner_ref = ref(null)
      const fc_ref = ref(null)

      const showLecturer = ref(isStudent())
      const zoomLink = ref(null)
      const otherDetails = ref(null)
      const noTimetable = ref(lst.getValue('noTimetable') === 'true')

      const event = ref({ extendedProps: {} })
    // -- END OLD DATA BLOCK
  

    onMounted(() => {
      if (noTimetable.value) {
        // this.alert('You don\'t have any timetabled classes or room bookings.')
      } else {
        // Timetable now cached on server so tell fc to fetch.
        fc(fc_ref).addEventSource(getEvents)
      }
      var time = Date.now()
      var diff = time - lst.getValue('timetableTime')
      var refreshRate = 900000

      // let _this = this

      if (diff > refreshRate) {
        spinner_ref.value.spin()
        axios.get('/timetable/timetable')
          .then(response => {
            fc(fc_ref).refetchEvents()
            lst.setValue('timetableTime', time)
            lst.setValue('noTimetable', response.data.noTimetable)
          })
          .finally(() => {
            spinner_ref.value.stop()
          })
      }

      window.addEventListener('popstate', removeBackdrop)
      const ua = window.navigator.userAgent
      const ie11 = ua.indexOf('rv:11.0') !== -1
      if (ie11) { // detect it's IE11
        window.addEventListener('hashchange', ieFix)
      }
    })

    function renderEvent (arg) {
      const props = arg.event.extendedProps
      const classif = props.classif

      // if month view, render one way. if not, the other way.
      const monthView = (arg.view.type == 'dayGridMonth')
      const ret = document.createElement('div')

      let classes = monthView ? 'event-monthview' : 'event-dayview'

      if (monthView) {
        if (props.isUserBooking) {
          classes += ' booking-monthview'
        } else if (classif == 'ONLIVE') {
          classes += ' online-live-monthview'
        } else if (classif == 'ONANY') {
          classes += ' online-anytime-monthview'
        } else {
          classes += ' on-campus-monthview'
        }
      }

      ret.setAttribute('class', classes)
      if (monthView) {
        const txt = document.createTextNode(' ')
        ret.appendChild(txt)
      } else {
        const oldDetails = arg.event.title
        // console.log('old details = ' + oldDetails)
        const icons = {
          'roomed': roomedIcon,
          'live': liveIcon,
          'anytime': anytimeIcon,
          'booking': bookingIcon,
          'location': locationIcon,
          'moodle': moodleIcon,
          'expandChev': expandChev
        }
        ret.appendChild(listviewDescriptionElem(props, oldDetails, icons))
      }

      return {
        domNodes: [ret]
      }
    }

    function postFormatEvent (arg) {
      const props = arg.event.extendedProps
      const classif = props.classif

      const monthView = (arg.view.type == 'dayGridMonth')
      // apply CSS classes for online live/online anytime/booking
      if (!monthView) {
        if (props.isUserBooking) {
          arg.el.classList.add('booking-listview')
        } else if (classif == 'ONLIVE') {
          arg.el.classList.add('online-live-listview')
        } else if (classif == 'ONANY') {
          arg.el.classList.add('online-anytime-listview')
        } else {
          arg.el.classList.add('on-campus-listview')
        }
      }
    }

    // Shows event details in a modal pop up
    function onEventClick (info) {
      if (info.view.type === 'dayGridMonth') {
        event.value = info.event
        event.value.startDate = moment(event.value.start, fc_ref).format('dddd DD/MM/YYYY')
        event.value.startTime = moment(event.value.start, fc_ref).format('h:mm a')
        event.value.endTime = moment(event.value.end, fc_ref).format('h:mm a')
        formatDetails(event.value.extendedProps.details, zoomLink, otherDetails)
        // $('#eventModal').modal('show')
        showTimetablePopup.value = true
      } else {
        if (info.event.title == 'Mobile app booking' || info.event.title == 'Mobile app booking (Provisional)') {
          return
        }

        // expand/collapse expand div, if it is there
        toggleExpandDiv(info)
      }
    }

    // Selects a date when a date is clicked
    function onDateClick (info) {
      if (info.view.type === 'dayGridMonth') {
        lst.setValue('timetableDate', info.date.getTime(), 0)
        fc(fc_ref).gotoDate(info.date)
        highlightDate(info.date)
      }
    }
    // Highlights a date

    function highlightDate (date) {
      // Remove previous highlight
      let els = document.getElementsByClassName('selected-date')
      Array.from(els).forEach(el => el.classList.remove('selected-date'))
 
      // Select cell for date and highlight
      let m_moment = moment(date, fc_ref)
      let datestamp = m_moment.format('YYYY-MM-DD')
      let selector = 'td[data-date=\'' + datestamp + '\']'

      els = document.querySelectorAll(selector)
      Array.from(els).forEach(el => el.classList.add('selected-date'))

    }

    /* Fetches events from server. Used over FullCalendar internal method so we can
    pass back login credentials. */
    function getEvents (info, successCallback) { /* commented out 'failureCallback' */
      spinner_ref.value.spin()
      axios.get('/timetable/timetable/events', {
        params: {
          start: dateToUnixTs(info.start),
          end: dateToUnixTs(info.end),
          ts: Date.now()
        }
      })
        .then(response => {
          successCallback(response.data)
        })
        .finally(() => {
          spinner_ref.value.stop()
        })
    }

    function removeBackdrop () {
      // $('.modal-backdrop').remove()
    }

    function ieFix () {
      window.location.reload()
    }
  
</script>

<style lang='scss'>
@import '@/scss/fullcalendar-customizations.scss';

/* style is not scoped, so we can influence the styles in fullcalendar ... */

table.timetable-loc-display {
  table-layout: fixed !important;
}
table.timetable-loc-display tr td {
  border: 0;
  padding: 8px !important; /* don't waste space */
}

/* this makes the date lineup */
.fc .fc-toolbar-title {
  float:right;
  margin-top:8px;
}

table.timetable-loc-display tr td:first-child {
  max-width: 15px;
}

.titleLand {
  margin-left:0;
}

.locationC {
  float:left;
}

.blueLink {
  color:#003865 !important;
  text-decoration:none !important;
}

.expandChev {
  margin-left:30%;
}
.rotateChev {
  transform:rotate(180deg);
}

.selected-date {
  background-color: #E8ECF2;
}

.dialogueTable th, td {
  vertical-align: top;
}

</style>
